import { AxiosResponse } from "axios";

export const getType = val => typeof val;

export const isFunction = val => getType(val) === "function";

export const isBoolean = val => getType(val) === "boolean";

export const isString = val => getType(val) === "string";

export const isNumber = val => getType(val) === "number";

export const isPrimitive = val => isBoolean(val) || isString(val) || isNumber(val);

export const isDate = val => val instanceof Date;

export const isArray = val => Array.isArray(val);

export const isObject = obj => obj !== null && typeof obj === "object";

export const keys = obj => Object.keys(obj);

export const onlyWhiteSpace = string => string.trim().length === 0;

export const looseEqual = (a, b) => {
  if (a === b) {
    return true;
  }
  let aValidType = isDate(a);
  let bValidType = isDate(b);
  if (aValidType || bValidType) {
    return aValidType && bValidType ? a.getTime() === b.getTime() : false;
  }
  aValidType = isArray(a);
  bValidType = isArray(b);
  if (aValidType || bValidType) {
    return aValidType && bValidType ? compareArrays(a, b) : false;
  }
  aValidType = isObject(a);
  bValidType = isObject(b);
  if (aValidType || bValidType) {
    /* istanbul ignore if: this if will probably never be called */
    if (!aValidType || !bValidType) {
      return false;
    }
    const aKeysCount = keys(a).length;
    const bKeysCount = keys(b).length;
    if (aKeysCount !== bKeysCount) {
      return false;
    }
    for (const key in a) {
      // eslint-disable-next-line no-prototype-builtins
      const aHasKey = a.hasOwnProperty(key);
      // eslint-disable-next-line no-prototype-builtins
      const bHasKey = b.hasOwnProperty(key);
      if ((aHasKey && !bHasKey) || (!aHasKey && bHasKey) || !looseEqual(a[key], b[key])) {
        return false;
      }
    }
  }
  return String(a) === String(b);
};

export const compareArrays = (a, b) => {
  if (a.length !== b.length) {
    return false;
  }
  let equal = true;
  for (let i = 0; equal && i < a.length; i++) {
    equal = looseEqual(a[i], b[i]);
  }
  return equal;
};
